import { Routes } from '@angular/router'
import { _deepCopy } from '@naturalcycles/js-lib'
import {
  BirthControlMethodBreakpointOption,
  BreakpointAction,
  ChoiceFunction,
  GoalBreakpointOption,
  QuizDataInput,
} from '@naturalcycles/shared'
import { allQuizSections } from '@src/app/constants/quiz.js'
import { addPageAtEndOfSection, addPageInSectionAfterPage } from '@src/app/core/util/quiz.util.js'
import { Page } from '@src/app/shared/typings/enum/pages.js'
import { DefaultSections } from '@src/app/shared/typings/enum/quiz.js'

const hormonalTransformFunction: ChoiceFunction<Page, QuizDataInput> = (flow, data) => {
  flow[allQuizSections.goal] = [
    Page.fertilityGoalInfo,
    Page.birthControlMethod,
    Page.sideEffects,
    Page.newsletter,
    Page.birthControlMethodInfo,
  ]

  flow[allQuizSections.cycle] =
    data?.fertilityGoal === GoalBreakpointOption.plan
      ? [Page.hormonalBirthControlHowLongPlan]
      : [Page.hormonalBirthControlHowLongPrevent]
  return flow
}

const copperIUDTransformFunction: ChoiceFunction<Page, QuizDataInput> = flow => {
  flow[allQuizSections.goal] = [
    Page.fertilityGoalInfo,
    Page.birthControlMethod,
    Page.sideEffects,
    Page.newsletter,
    Page.birthControlMethodInfo,
  ]

  flow[allQuizSections.cycle] = [
    Page.cycleLength,
    Page.periodRegularity,
    Page.periodRegularityInfo,
    Page.cycleStartDate,
    Page.medicalConditionsPrevent,
  ]
  return flow
}

const addNewsletterPage = (flow: Page[][], page: Page, infoPage: Page): Page[][] => {
  if (!flow[allQuizSections.goal]?.includes(page)) {
    return addPageAtEndOfSection(flow, page, DefaultSections.goal)
  }
  return addPageInSectionAfterPage(flow, infoPage, page, DefaultSections.goal)
}

const nonHormonalTransformFunction: ChoiceFunction<Page, QuizDataInput> = flow => {
  const f = _deepCopy(flow)

  f[allQuizSections.cycle] = [
    Page.cycleLength,
    Page.periodRegularity,
    Page.periodRegularityInfo,
    Page.cycleStartDate,
    Page.medicalConditionsPrevent,
  ]

  return addNewsletterPage(f, Page.birthControlMethod, Page.newsletter)
}

export const birthControlMethod358: BreakpointAction<
  BirthControlMethodBreakpointOption,
  Page,
  QuizDataInput
> = {
  // Hormonal
  [BirthControlMethodBreakpointOption.pill]: hormonalTransformFunction,
  [BirthControlMethodBreakpointOption.shot]: hormonalTransformFunction,
  [BirthControlMethodBreakpointOption.implant]: hormonalTransformFunction,
  [BirthControlMethodBreakpointOption.hormonalIUD]: hormonalTransformFunction,
  [BirthControlMethodBreakpointOption.patch]: hormonalTransformFunction,
  [BirthControlMethodBreakpointOption.nuvaRing]: hormonalTransformFunction,

  // Copper IUD
  [BirthControlMethodBreakpointOption.copperIUD]: copperIUDTransformFunction,

  // Non-hormonal
  [BirthControlMethodBreakpointOption.condom]: nonHormonalTransformFunction,
  [BirthControlMethodBreakpointOption.pullOut]: nonHormonalTransformFunction,
  [BirthControlMethodBreakpointOption.other]: nonHormonalTransformFunction,
  [BirthControlMethodBreakpointOption.none]: nonHormonalTransformFunction,
}

export const ab358Routes: Routes = [
  {
    path: Page.newsletter,
    loadComponent: () =>
      import('./pages/newsletter/newsletter.page.component').then(m => m.NewsletterPage),
  },
]
